/* tslint:disable */

declare var Object: any;
export interface ERPsalesPlaningInterface {
  "id"?: number;
}

export class ERPsalesPlaning implements ERPsalesPlaningInterface {
  "id": number;
  constructor(data?: ERPsalesPlaningInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPsalesPlaning`.
   */
  public static getModelName() {
    return "ERPsalesPlaning";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPsalesPlaning for dynamic purposes.
  **/
  public static factory(data: ERPsalesPlaningInterface): ERPsalesPlaning{
    return new ERPsalesPlaning(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPsalesPlaning',
      plural: 'ERPsalesPlanings',
      path: 'ERPsalesPlanings',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPsalesPlaning.ts